import { useState, useEffect } from "react";
import "../css/DealersList.css";

// ---------------------------------------------------------------------------
// Mock city data — replace with API call / props from your Cities table
// ---------------------------------------------------------------------------
// const CITIES = [
//   { id: 1, name: "Mumbai",    state: "Maharashtra" },
//   { id: 2, name: "Bengaluru", state: "Karnataka"   },
//   { id: 3, name: "Delhi",     state: "Delhi"        },
//   { id: 4, name: "Chennai",   state: "Tamil Nadu"   },
//   { id: 5, name: "Hyderabad", state: "Telangana"    },
// ];

// const INITIAL_DEALERS = [
//   {
//     id: 101, cityId: 1,
//     name: "Numeros Motors Rajajinagar", address: "No. 25, 1st Main Road, 4th Block, Rajaji Nagar, Bengaluru 560021",
//     phone: "+91 123456789", email: "numerosmotors@example.com", mapLink: "https://maps.google.com",
//   },

// ];

const EMPTY_FORM = { cityId: "", name: "", address: "", phone: "", email: "", mapLink: "" };

// ---------------------------------------------------------------------------
export default function DealersList() {
    const [dealers, setDealers] = useState([]);
const [cities, setCities] = useState([]);
const [states, setStates] = useState([]);
  //const [dealers, setDealers]         = useState(INITIAL_DEALERS);
  const [showModal, setShowModal]     = useState(false);
  const [form, setForm]               = useState(EMPTY_FORM);
  const [errors, setErrors]           = useState({});
  const [editId, setEditId]           = useState(null);
  const [activeCityId, setActiveCityId] = useState("all"); // tab filter
  const [deleteConfirm, setDeleteConfirm] = useState(null); // dealer id pending delete

  const DEALERS_API = "/api/dealerslist";
const CITIES_API = "/api/cities";
const STATES_API = "/api/states";


const fetchCities = async () => {
  try {

    const res = await fetch(CITIES_API);
    const data = await res.json();

    if (data.success) {

      const formatted = data.data.map((item) => ({
        id: item.id,
        name: item.city,
        state: item.state,
        image: item.image
      }));

      setCities(formatted);
    }

  } catch (error) {
    console.log(error);
  }
};



const fetchStates = async () => {
  try {

    const res = await fetch(STATES_API);
    const data = await res.json();

    if (data.success) {

      const formatted = data.data.map((item) => ({
        id: item.id,
        name: item.name,
        // state: item.state,
        // image: item.image
      }));

      setStates(formatted);
    }

  } catch (error) {
    console.log(error);
  }
};


const fetchDealers = async () => {
  try {

    const res = await fetch(DEALERS_API);
    const data = await res.json();

    if (data.success) {

      const formatted = data.data.map((item) => ({
        id: item.id,
        cityId: item.cityId,
        name: item.name,
        address: item.address,
        phone: item.phone,
        email: item.email,
        mapLink: item.mapLink
      }));

      setDealers(formatted);
    }

  } catch (error) {
    console.log(error);
  }
};

useEffect(() => {
  fetchCities();
  //fetchStates();
  fetchDealers();
}, []);

  // ── helpers ──────────────────────────────────────────────────────────────
  const cityName = (id) => cities.find((c) => c.id === id)?.name ?? "—";

  const filteredDealers =
    activeCityId === "all"
      ? dealers
      : dealers.filter((d) => d.cityId === activeCityId);

  // group filtered dealers by city for the list view
  const grouped = cities.reduce((acc, city) => {
    const list = filteredDealers.filter((d) => d.cityId === city.id);
    if (list.length) acc.push({ city, list });
    return acc;
  }, []);

  // ── form ─────────────────────────────────────────────────────────────────
  const handleInput = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    setErrors((err) => ({ ...err, [name]: "" }));
  };

  const validate = () => {
    const e = {};
    if (!form.cityId)          e.cityId  = "Please select a city.";
    if (!form.name.trim())     e.name    = "Dealer name is required.";
    if (!form.address.trim())  e.address = "Address is required.";
    if (!form.phone.trim())    e.phone   = "Phone number is required.";
    if (!form.email.trim())    e.email   = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = "Enter a valid email.";
    return e;
  };

  const openAdd = () => {
    setEditId(null);
    setForm(EMPTY_FORM);
    setErrors({});
    setShowModal(true);
  };

  const openEdit = (dealer) => {
    setEditId(dealer.id);
    setForm({
      cityId:  dealer.cityId,
      name:    dealer.name,
      address: dealer.address,
      phone:   dealer.phone,
      email:   dealer.email,
      mapLink: dealer.mapLink,
    });
    setErrors({});
    setShowModal(true);
  };

 const handleSubmit = async () => {

  const e = validate();

  if (Object.keys(e).length) {
    setErrors(e);
    return;
  }

  try {

    const payload = {
      cityId: Number(form.cityId),
      name: form.name,
      address: form.address,
      phone: form.phone,
      email: form.email,
      mapLink: form.mapLink
    };

    // UPDATE
    if (editId) {

      const res = await fetch(`${DEALERS_API}/${editId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      const data = await res.json();

      if (data.success) {
        await fetchDealers();
        closeModal();
      }

    }

    // ADD
    else {

      const res = await fetch(DEALERS_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      const data = await res.json();

      if (data.success) {
        await fetchDealers();
        closeModal();
      }
    }

  } catch (error) {
    console.log(error);
  }
};

  const closeModal = () => {
    setShowModal(false);
    setForm(EMPTY_FORM);
    setErrors({});
    setEditId(null);
  };

  const confirmDelete = (id) => setDeleteConfirm(id);
 
  const doDelete = async () => {

  try {

    const res = await fetch(`${DEALERS_API}/${deleteConfirm}`, {
      method: "DELETE"
    });

    const data = await res.json();

    if (data.success) {
      await fetchDealers();
      setDeleteConfirm(null);
    }

  } catch (error) {
    console.log(error);
  }
};

  // ── render ────────────────────────────────────────────────────────────────
  return (
    <div className="dl-page">

      {/* ── Page Header ── */}
      <div className="dl-header">
        <div className="dl-title-group">
          <div className="dl-page-icon">
            <IconStore />
          </div>
          <div>
            <h1 className="dl-page-title">Dealers List</h1>
            <p className="dl-page-subtitle">
              {dealers.length} {dealers.length === 1 ? "dealer" : "dealers"} across {cities.length} cities
            </p>
          </div>
        </div>
        <button className="dl-btn-primary" onClick={openAdd}>+ Add Dealer</button>
      </div>

      {/* ── City Tabs ── */}
      <div className="dl-tabs-wrap">
        <div className="dl-tabs">
          <button
            className={`dl-tab ${activeCityId === "all" ? "dl-tab-active" : ""}`}
            onClick={() => setActiveCityId("all")}
          >
            All
            <span className="dl-tab-count">{dealers.length}</span>
          </button>
          {cities.map((city) => {
            const count = dealers.filter((d) => d.cityId === city.id).length;
            return (
              <button
                key={city.id}
                className={`dl-tab ${activeCityId === city.id ? "dl-tab-active" : ""}`}
                onClick={() => setActiveCityId(city.id)}
              >
                {city.name}
                <span className="dl-tab-count">{count}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* ── Content ── */}
      <div className="dl-content">
        {grouped.length === 0 ? (
          <div className="dl-empty">
            <p>No dealers found.</p>
            <button className="dl-btn-primary" style={{ marginTop: 14 }} onClick={openAdd}>
              + Add Dealer
            </button>
          </div>
        ) : (
          grouped.map(({ city, list }) => (
            <div className="dl-city-section" key={city.id}>
              {/* city heading */}
              <div className="dl-city-heading">
                <span className="dl-city-dot" />
                <span className="dl-city-name">{city.name}</span>
                <span className="dl-city-state">{city.state}</span>
                <span className="dl-city-pill">{list.length}</span>
              </div>

              {/* table */}
              <div className="dl-table-wrap">
                <table className="dl-table">
                  <thead>
                    <tr>
                      <th>Dealer Name</th>
                      <th>Address</th>
                      <th>Phone</th>
                      <th>Email</th>
                      <th>Map</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.map((dealer) => (
                      <tr key={dealer.id}>
                        <td className="dl-td-name">{dealer.name}</td>
                        <td className="dl-td-address">{dealer.address}</td>
                        <td>
                          <a href={`tel:${dealer.phone}`} className="dl-link">{dealer.phone}</a>
                        </td>
                        <td>
                          <a href={`mailto:${dealer.email}`} className="dl-link">{dealer.email}</a>
                        </td>
                        <td>
                          {dealer.mapLink ? (
                            <a href={dealer.mapLink} target="_blank" rel="noreferrer" className="dl-map-link">
                              <IconMap /> View
                            </a>
                          ) : (
                            <span className="dl-na">—</span>
                          )}
                        </td>
                        <td>
                          <div className="dl-row-actions">
                            <button className="dl-act-edit" onClick={() => openEdit(dealer)}>
                              <IconEdit /> Edit
                            </button>
                            <button className="dl-act-del" onClick={() => confirmDelete(dealer.id)}>
                              <IconTrash /> Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))
        )}
      </div>

      {/* ── Add / Edit Modal ── */}
      {showModal && (
        <div className="dl-backdrop" onClick={closeModal}>
          <div className="dl-modal" onClick={(e) => e.stopPropagation()}>
            <div className="dl-modal-header">
              <h2 className="dl-modal-title">{editId ? "Edit Dealer" : "Add Dealer"}</h2>
              <button className="dl-modal-close" onClick={closeModal}>✕</button>
            </div>

            <div className="dl-modal-body">
              {/* City */}
              <div className="dl-field">
                <label className="dl-label">City</label>
                <select
                  className={`dl-select${errors.cityId ? " dl-input-err" : ""}`}
                  name="cityId"
                  value={form.cityId}
                  onChange={handleInput}
                >
                  <option value="">Select city…</option>
                  {cities.map((c) => (
                    <option key={c.id} value={c.id}>{c.name} — {c.state}</option>
                  ))}
                </select>
                {errors.cityId && <span className="dl-err">{errors.cityId}</span>}
              </div>

              {/* Name */}
              <div className="dl-field">
                <label className="dl-label">Dealer Name</label>
                <input
                  className={`dl-input${errors.name ? " dl-input-err" : ""}`}
                  name="name" value={form.name} onChange={handleInput}
                  placeholder="e.g. Speedway Motors"
                  autoFocus
                />
                {errors.name && <span className="dl-err">{errors.name}</span>}
              </div>

              {/* Address */}
              <div className="dl-field">
                <label className="dl-label">Address</label>
                <textarea
                  className={`dl-textarea${errors.address ? " dl-input-err" : ""}`}
                  name="address" value={form.address} onChange={handleInput}
                  placeholder="Full address with pincode"
                  rows={2}
                />
                {errors.address && <span className="dl-err">{errors.address}</span>}
              </div>

              {/* Phone + Email side by side */}
              <div className="dl-row">
                <div className="dl-field">
                  <label className="dl-label">Phone Number</label>
                  <input
                    className={`dl-input${errors.phone ? " dl-input-err" : ""}`}
                    name="phone" value={form.phone} onChange={handleInput}
                    placeholder="+91 98000 00000"
                  />
                  {errors.phone && <span className="dl-err">{errors.phone}</span>}
                </div>
                <div className="dl-field">
                  <label className="dl-label">Email</label>
                  <input
                    className={`dl-input${errors.email ? " dl-input-err" : ""}`}
                    name="email" value={form.email} onChange={handleInput}
                    placeholder="dealer@example.com"
                    type="email"
                  />
                  {errors.email && <span className="dl-err">{errors.email}</span>}
                </div>
              </div>

              {/* Map Link */}
              <div className="dl-field">
                <label className="dl-label">Map Link <span className="dl-optional">(optional)</span></label>
                <input
                  className="dl-input"
                  name="mapLink" value={form.mapLink} onChange={handleInput}
                  placeholder="https://maps.google.com/..."
                />
              </div>
            </div>

            <div className="dl-modal-footer">
              <button className="dl-btn-ghost" onClick={closeModal}>Cancel</button>
              <button className="dl-btn-primary" onClick={handleSubmit}>
                {editId ? "Save Changes" : "Add Dealer"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Delete Confirm ── */}
      {deleteConfirm && (
        <div className="dl-backdrop" onClick={() => setDeleteConfirm(null)}>
          <div className="dl-confirm" onClick={(e) => e.stopPropagation()}>
            <div className="dl-confirm-icon"><IconTrash /></div>
            <h3 className="dl-confirm-title">Delete Dealer?</h3>
            <p className="dl-confirm-msg">
              This will permanently remove{" "}
              <strong>{dealers.find((d) => d.id === deleteConfirm)?.name}</strong> from the list.
            </p>
            <div className="dl-confirm-actions">
              <button className="dl-btn-ghost" onClick={() => setDeleteConfirm(null)}>Cancel</button>
              <button className="dl-btn-danger" onClick={doDelete}>Yes, Delete</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Inline SVG icons ──────────────────────────────────────────────────────
function IconStore() {
  return (
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round"
        d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 22V12h6v10" />
    </svg>
  );
}
function IconEdit() {
  return (
    <svg width="12" height="12" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
    </svg>
  );
}
function IconTrash() {
  return (
    <svg width="12" height="12" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round"
        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
    </svg>
  );
}
function IconMap() {
  return (
    <svg width="12" height="12" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
      <path strokeLinecap="round" strokeLinejoin="round"
        d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
    </svg>
  );
}